import PropTypes from 'prop-types';

const CrossIcon = ({ color }) => (
  <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M2.734 2.734L0 5.469L11.237 16.738L22.474 28.007L11.237 39.276L0 50.545L2.734 53.28L5.469 56.014L16.738 44.777L28.007 33.54L39.276 44.777L50.545 56.014L53.28 53.28L56.014 50.545L44.777 39.276L33.54 28.007L44.777 16.738L56.014 5.469L53.28 2.734L50.545 0L39.276 11.237L28.007 22.474L16.738 11.237L5.469 0L2.734 2.734Z" fill={color} />
  </svg>

);

CrossIcon.propTypes = {
  color: PropTypes.string.isRequired,
};

export default CrossIcon;
